import { render, staticRenderFns } from "./PromoCodeTabs.vue?vue&type=template&id=2bf29704&scoped=true"
import script from "./PromoCodeTabs.vue?vue&type=script&lang=js"
export * from "./PromoCodeTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf29704",
  null
  
)

export default component.exports